import { Component, OnInit, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { FormGroup, FormControl, Validators, FormControlDirective } from '@angular/forms';
import { PartnershipService } from '../partnership.service';
import { PartnerRelationship } from '../models';

@Component({
  selector: 'app-change-primary-contact',
  templateUrl: './change-primary-contact.component.html',
  styleUrls: ['./change-primary-contact.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class ChangePrimaryContactComponent implements OnInit {

  @Input() PersonId: number;
  @Input() DisplayRelationshipIds: any[];
  @Input() Relationships: [];

  @Output() RelationshipAndContactId = new EventEmitter<any[]>();
  @Output() IsPrimaryContactReady = new EventEmitter<boolean>();

  partnerRelationship: PartnerRelationship[];
  aRelationAndContact = [];
  isValid = false;
  loading = false;
  failedToLoad = false;
  partnershipsLoaded = false;

  public changePrimaryContactForm: FormGroup = new FormGroup({
    PrimaryContact: new FormControl('')
  });
  primaryContact = this.changePrimaryContactForm.get('PrimaryContact');
  constructor(private partnershipService: PartnershipService) { }

  ngOnInit() {
    if (typeof this.PersonId !== 'undefined') {
      this.loading = true;
      this.partnershipService.findByPerson(this.PersonId)
        .subscribe((partnerRelationshipData: any) => {
          this.partnerRelationship = <PartnerRelationship[]>partnerRelationshipData.data;
          this.partnerRelationship = this.partnerRelationship.filter(this.filterRelationships.bind(this));
          if (this.partnerRelationship.length > 0) {
            this.partnershipsLoaded = true;
          }
          for (let i = 0; i < this.partnerRelationship.length; i++) {
            /* Remove the current primary contact from the contacts list */
            this.partnerRelationship[i].PartnerUser = this.partnerRelationship[i].PartnerUser.filter( (el) => (el.Person.PersonId !== this.PersonId && el.Person.IsActive) );
          }
          this.loading = false;
        });
    } else {
      this.failedToLoad = true;
    }
  }

  filterRelationships(relationship: any): any {
    for ( let count = 0; count < relationship.PartnerUser.length; count++) {
      /* Display only those relationship ids that are passed in via this.DisplayRelationshipIds */
      if (typeof this.DisplayRelationshipIds !== 'undefined' && this.DisplayRelationshipIds.length > 0) {
        if (this.DisplayRelationshipIds.indexOf(relationship.RelationshipId) === -1) {
          break;
        }
      }
      /* Filter the relationships where this.PersonId is not a Primary Contact */
      if ( relationship.PartnerUser[count].Person.PersonId === this.PersonId && relationship.PartnerUser[count].IsPrimary ) {
        return relationship;
      }
    }
  }

  assignPrimaryContact(RelationshipId: number, ContactPerson: any): void {
    let bInsertIntoArray = true;
    /* Create an array of objects: [{'RelationshipId': RelationshipId, 'PrimaryContactId': PrimaryContactId}] */
    for (let i = 0; i < this.aRelationAndContact.length; i++) {
      if (this.aRelationAndContact[i].RelationshipId === RelationshipId && ContactPerson.Person.PersonId !== '') {
        this.aRelationAndContact[i].PrimaryContactId = ContactPerson.Person.PersonId;
        bInsertIntoArray = false;
        break;
      }
    }
    if ( (this.aRelationAndContact.length === 0 || bInsertIntoArray ) && ContactPerson.Person.PersonId !== '') {
      this.aRelationAndContact.push({
        'RelationshipId': RelationshipId,
        'NewPrimaryContactId': ContactPerson.Person.PersonId
      });
    }
    this.isValid = this.aRelationAndContact.length === this.partnerRelationship.length ? true : false;
    this.RelationshipAndContactId.emit(this.aRelationAndContact);
    this.IsPrimaryContactReady.emit(this.isValid);
  }

}
